import { useState } from 'react';
import {
  Typography,
  Divider,
  TextField,
  Alert,
  Box,
  Button,
} from '@mui/material';

const RedirectUriSettings = ({ deployment, onSave }) => {
  const [redirectUri, setRedirectUri] = useState(deployment?.redirectUri || '');
  const [error, setError] = useState('');

  const isValidDomain = (uri) => {
    try {
      const url = new URL(uri);
      return url.protocol === 'https:' && url.hostname.includes('.');
    } catch {
      return false;
    }
  };

  const handleUriChange = (event) => {
    const value = event.target.value;
    setRedirectUri(value);

    if (!value) {
      setError('Bitte geben Sie eine URI ein');
    } else if (!isValidDomain(value)) {
      setError(
        'Bitte geben Sie eine gültige HTTPS-URI ein (z.B. https://app.example.com)',
      );
    } else {
      setError('');
    }
  };

  const handleSave = () => {
    onSave({ redirectUri: redirectUri });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ my: 1, mb: 2, pr: '80px' }}>
        <Typography variant="h6">Anwendungs-URL für das Pass-Tool</Typography>
        <Divider />
      </Box>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Geben Sie die URI ein, unter der die Anwendung erreichbar sein soll. Sie
        benötigen Zugriff auf die DNS-Einstellungen dieser Domain.
      </Typography>
      {deployment ? (
        <>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Aktuelle URI: <strong>{deployment.redirectUri}</strong>
          </Typography>
          <Alert severity="info" sx={{ mb: 3 }}>
            Wenn Sie die URI ändern, müssen Sie ihre DNS-Einträge erneut
            setzten, um zu verifizieren, dass diese Domain ihnen gehört.
          </Alert>
        </>
      ) : (
        <Alert severity="info" sx={{ mb: 3 }}>
          Die URI muss über HTTPS erreichbar sein und Sie müssen die
          Berechtigung haben, DNS-Einträge für diese Domain zu konfigurieren.
          Nach der Buchung erhalten Sie eine E-Mail mit einer Anleitung zur
          Einrichtung der App.
        </Alert>
      )}

      <Box sx={{ mt: 2 }}>
        <TextField
          fullWidth
          label="Deployment URI"
          value={redirectUri}
          onChange={handleUriChange}
          error={!!error}
          helperText={error || ''}
          placeholder="https://app.example.com"
        />
      </Box>
      <Button
        variant="contained"
        color="primary"
        onClick={handleSave}
        sx={{ mt: 'auto', ml: 'auto' }} // This pushes the button to the bottom right
      >
        Speichern
      </Button>
    </Box>
  );
};

export default RedirectUriSettings;
